'use strict';

export default class VideoLink {
  constructor() {
    this.name = 'video-link';

  }
}
